import axiosInstance from '../../lib/axios';

const PLATFORM = 'web-admin';
const GOOGLE_PLATFORM = 'WEB';
const APPLICATION = process.env.REACT_APP_APPLICATION_NAME || 'com.ezymind.internal.web';

export const sendOTP = async (phoneNumber) => {
  const response = await axiosInstance.post('/auth/otp/send/', {
    phone_number: phoneNumber,
    platform: PLATFORM,
    application: APPLICATION,
  });
  return response.data;
};

export const googleLogin = async (idToken) => {
  const response = await axiosInstance.post('/auth/google/', {
    id_token: idToken,
    platform: GOOGLE_PLATFORM,
    application: APPLICATION,
  });
  return response.data;
};

export const verifyOTP = async (phoneNumber, otpCode) => {
  const response = await axiosInstance.post('/auth/otp/verify/', {
    phone_number: phoneNumber,
    platform: PLATFORM,
    application: APPLICATION,
    otp_code: otpCode,
  });
  return response.data;
};

export const resendOTP = async (phoneNumber) => {
  const response = await axiosInstance.post('/auth/otp/resend/', {
    phone_number: phoneNumber,
    platform: PLATFORM,
    application: APPLICATION,
  });
  return response.data;
};

export const getMe = async () => {
  const response = await axiosInstance.get('/auth/me/');
  return response.data;
};

const scopedAuthHeader = (token) => ({ Authorization: `Bearer ${token}` });

export const enrollMFAStart = async (enrollmentToken) => {
  const response = await axiosInstance.post(
    '/auth/2fa/enroll/start/',
    {},
    { headers: scopedAuthHeader(enrollmentToken) }
  );
  return response.data;
};

export const enrollMFAConfirm = async (enrollmentToken, code) => {
  const response = await axiosInstance.post(
    '/auth/2fa/enroll/confirm/',
    { code },
    { headers: scopedAuthHeader(enrollmentToken) }
  );
  return response.data;
};

export const verifyMFA = async (mfaToken, code, trustDevice) => {
  const response = await axiosInstance.post(
    '/auth/2fa/verify/',
    { code, trust_device: trustDevice },
    { headers: scopedAuthHeader(mfaToken), withCredentials: true }
  );
  return response.data;
};

export const verifyMFARecovery = async (mfaToken, recoveryCode) => {
  const response = await axiosInstance.post(
    '/auth/2fa/recovery/',
    { recovery_code: recoveryCode },
    { headers: scopedAuthHeader(mfaToken), withCredentials: true }
  );
  return response.data;
};

export const disableMFA = async (code) => {
  const response = await axiosInstance.post('/auth/2fa/disable/', { code });
  return response.data;
};

export const regenerateRecoveryCodes = async (code) => {
  const response = await axiosInstance.post('/auth/2fa/recovery-codes/regenerate/', { code });
  return response.data;
};

export const listTrustedDevices = async () => {
  const response = await axiosInstance.get('/auth/2fa/trusted-devices/');
  return response.data;
};

export const revokeTrustedDevice = async (deviceId) => {
  const response = await axiosInstance.delete(`/auth/2fa/trusted-devices/${deviceId}/`);
  return response.data;
};

export const revokeAllTrustedDevices = async () => {
  const response = await axiosInstance.post('/auth/2fa/trusted-devices/revoke-all/');
  return response.data;
};
